// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_qzC82","item":"item_rCDuX","g-body-pc":"g-body-pc","a":"a_Fv-Wi"};